module.exports = __webpack_public_path__ + "img/solve_pic01.55cb73a4.jpg";